import { Link } from 'react-router';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import XwordsUtils, { XWORDS_INITIAL_KEYS } from './XwordsUtils';

interface Props {
    lang: MultiLang;
    catId: number;
}

const XwordsInitialFieldset = (props: Props) => {
    const { lang, catId } = props;
    const initial = XwordsUtils.getCountInitials(catId);
    const initials = XWORDS_INITIAL_KEYS.map((value) => {
        const num = initial[value.key];
        const url = XwordsUtils.getLetterUrl(value.key, catId);
        const label = Functions.mlang(value.label, lang);
        return (
            <span key={value.key}>
                {num === 0 ? (
                    label
                ) : (
                    <Link to={url} title={`[ ${num} ]`}>
                        {label}
                    </Link>
                )}
            </span>
        );
    });
    return (
        <fieldset className="item initial">
            <legend className="title">
                {Functions.mlang('[en]Initials[/en][ja]頭文字（イニシャル）別[/ja]', lang)}
            </legend>
            <div className="body">
                <div>{initials.slice(0, 26)}</div>
                <div>{initials.slice(26)}</div>
            </div>
        </fieldset>
    );
};

export default XwordsInitialFieldset;
